import {Device} from 'platform/foundation';

export const getDefaultDirection = (device: Device) =>
  device === 'mobile' || device === 'tablet' ? 'row' : 'column';
